import * as React from "react";
import Box from "@mui/material/Box";

import { techStackUtils } from "../../utils/techStackUtils";

import Badge from "react-bootstrap/Badge";
import Card from "@mui/material/Card";
export default function TechStack() {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        "& > :not(style)": {
          m: 1,
          width: 138,
          height: 128,
          backgroundColor: "grey",
        },

        xs: {
          "& > :not(style)": {
            m: 1,
            width: 158,
            height: 128,
            backgroundColor: "grey",
          },
        },
      }}
    >
      {techStackUtils.map((item) => (
        <Card
          key={item.id}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "20px",
            width: "150px",
            height: "200px",
            backgroundColor: "lightblue",
            transition: "background-color 0.3s",

            cursor: "pointer",
            "&:hover": {
              backgroundColor: "lightgrey",
            },
          }}
        >
          <item.icon size={60} color={item.color} />
          <Badge
            bg={item.color}
            style={{
              padding: "0.5em",
              backgroundColor: item.color,
              fontSize: "8px",
            }}
          >
            {item.name}
          </Badge>
        </Card>
      ))}
    </Box>
  );
}
